import { TLF_VIEW_MODES } from "aic/utility/interface"; // Needs to be imported from aic to avoid circular dependency with itself
import { SearchableEditorBlocks } from "../../functions/api/enums";
import { TlfContextProps } from "./interface";

export const tlfContextInitialState: TlfContextProps = {
  forcePushToParent: false,
  changed: false,
  commentPanelStatus: {
    highlightCommentId: "",
    activeRelatedTo: "",
    showComments: false,
    commentFilter: "all",
  },
  editorBlocksSearchPanelStatus: {
    showSearchPanel: false,
    searchText: "",
    blocksToSearch: Object.values(SearchableEditorBlocks),
  },
  isSubscribed: false,
  ixSaveVersion: -1,
  ixTlfDataVersion: -1,
  receivedMessages: [],
  showModalWindow: "",
  showTrafficLights: true,
  tlfData: null,
  tlfDataVersions: [],
  tlfViewMode: TLF_VIEW_MODES[0],
  applyDelayedHierarchyUpdatesTrigger: 0,
  discardDelayedHierarchyUpdatesTrigger: 0,
  delayedHierarchyUpdates: false,
};
